import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.BulkCreateTasksModal.title',
    defaultMessage: 'Create tasks',
  },
})
